import type { OnboardInfoDto } from '@/data/dtos/user/onboardInfoDto';
import type { OnboardInfoInput } from '@/domain/input/user/onboardInfoInput';
import { UserUtils } from '@/domain/utils/userUtils';

export class OnboardInfoRemapper {
  static toDto(input: OnboardInfoInput): OnboardInfoDto {
    return {
      profileImage: input.profileImage,
      userNameInfo: UserUtils.generateUserNameInfo(input.name.trim()),
      username: input.username.trim(),
      bio: input.bio,
      subscriptonCharge: input.subscriptionCharge,
    };
  }
}
